import React from 'react';
import { FadeIn } from './FadeIn';
export function Bonuses() {
  const bonuses = [{
    icon: '📱',
    title: 'Kit Express de Respuestas para Cerrar por WhatsApp',
    desc: 'Scripts listos para consulta, defensa de precio, seña y seguimiento.',
    value: '$5.000'
  }, {
    icon: '📋',
    title: 'Checklist Maestro de Visita y Cierre en Obra',
    desc: 'Las 10 preguntas obligatorias y guiones para cerrar cada visita.',
    value: '$5.000'
  }, {
    icon: '✨',
    title: 'Guía Rápida de Limpieza, Cuidado y Entrega al Cliente',
    desc: 'Checklist de entrega y protocolo de 7 pasos para cerrar como profesional.',
    value: '$5.000'
  }];
  return <section className="py-12 relative" data-id="element-16">
      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-17">
        <FadeIn data-id="element-18">
          <div className="text-center mb-10" data-id="element-19">
            <h2 className="text-4xl md:text-6xl font-bold mb-4 text-white" data-id="element-20">
              🎁 PACK DE BONOS MAESTRO
            </h2>
            <p className="text-gold text-xl md:text-2xl font-bold uppercase tracking-wider mb-4" data-id="element-21">
              SIEMPRE INCLUIDOS
            </p>
            <p className="text-gray-400 max-w-2xl mx-auto text-sm md:text-base" data-id="element-22">
              Tres herramientas prácticas: scripts, checklists y protocolos
              listos para usar. Sin relleno — solo lo que funciona.
            </p>
          </div>
        </FadeIn>

        <div className="space-y-4 mb-12" data-id="element-23">
          {bonuses.map((bono, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-24">
              <div className="bg-surface p-6 rounded-2xl border border-white/5 flex flex-col md:flex-row md:items-center justify-between gap-4 hover:border-gold/30 transition-colors" data-id="element-25">
                <div className="flex items-start gap-4" data-id="element-26">
                  <span className="text-2xl font-bold text-gold opacity-50" data-id="element-27">
                    0{i + 1}
                  </span>
                  <div data-id="element-28">
                    <h3 className="text-lg font-bold text-white mb-1" data-id="element-29">
                      {bono.icon} BONO {i + 1} — {bono.title}
                    </h3>
                    <p className="text-gray-400 text-sm" data-id="element-30">{bono.desc}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 md:flex-col md:items-end md:gap-1 shrink-0" data-id="element-31">
                  <span className="text-gray-500 line-through text-sm" data-id="element-32">
                    Valor: {bono.value}
                  </span>
                  <span className="bg-gold text-background font-bold px-3 py-1 rounded-md text-sm uppercase tracking-wide" data-id="element-33">
                    GRATIS
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-34">
          <div className="text-center p-8 rounded-2xl bg-gradient-to-r from-surface to-surfaceLight border border-gold/20" data-id="element-35">
            <p className="text-xl md:text-2xl font-medium" data-id="element-36">
              Valor total de los bonos:{' '}
              <span className="line-through text-gray-500" data-id="element-37">$15.000</span>{' '}
              <span className="text-gold font-bold" data-id="element-38">
                → GRATIS con tu Sistema Maestro
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}